module.exports = __webpack_public_path__ + "img/incident_report.4805f40a.svg";